<template>
  <div class="p-2 border-top">
    <b-row class="mb-1 text-center" v-if="Object.keys(user).length > 0">
      <b-col>
        <small class="font-weight-bold"
          >Usuário adicionado em
          {{ user.createdAt | moment("DD [de] MMM [de] YYYY") }}</small
        >
      </b-col>
    </b-row>
    <div class="d-flex flex-row" :class="'justify-content-between'">
      <b-button
        v-if="Object.keys(user).length > 0"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'outline-primary'"
        @click="$emit('open-sidebar-form')"
        >Editar
      </b-button>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        :variant="
          user.deletedAt === null ? 'outline-danger' : 'outline-success'
        "
        @click="$emit('disable-enable')"
        class="d-none d-md-block"
      >
        <span v-if="user.deletedAt === null">Desativar</span>
        <span v-else>Ativar</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BRow, BCol } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BRow,
    BCol,
  },

  directives: {
    Ripple,
  },

  props: {
    user: {
      type: Object,
      require: true,
    },
  },
};
</script>
